import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tichete-page" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "grid-card" }
const _hoisted_4 = { class: "grid-head" }
const _hoisted_5 = { class: "nr-badge" }
const _hoisted_6 = {
  key: 0,
  class: "stare-pill inchis"
}
const _hoisted_7 = {
  key: 1,
  class: "stare-pill deschis"
}
const _hoisted_8 = { class: "dlg-head" }
const _hoisted_9 = { class: "dlg-ic" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "hero-txt" }, [
        _createElementVNode("div", { class: "hero-eyebrow" }, "PORTAL HR"),
        _createElementVNode("h1", { class: "hero-title" }, "Tichete HR"),
        _createElementVNode("p", { class: "hero-sub" }, "Cereri de adeverințe și documente către HR. Urmărește starea și răspunsul.")
      ], -1)),
      _createVNode(_component_v_btn, {
        class: "btn-nou",
        "prepend-icon": "mdi-plus",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogTicket = true))
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
          _createTextVNode("Tichet nou", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "#ff5722",
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("mdi-ticket-confirmation-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[11] || (_cache[11] = _createElementVNode("span", null, "Tichetele mele", -1))
      ]),
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.dataSource,
        "show-borders": false,
        "show-column-lines": false,
        "show-row-lines": true,
        "hover-state-enabled": true,
        "row-alternation-enabled": false,
        "no-data-text": "Nu ai niciun tichet."
      }, {
        nrCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_5, _toDisplayString(data.data.TicketNr || '—'), 1)
        ]),
        raspunsCell: _withCtx(({ data }) => [
          _createElementVNode("span", {
            class: _normalizeClass({ 'text-muted': !data.data.HRMessage })
          }, _toDisplayString(data.data.HRMessage || 'În așteptare…'), 3)
        ]),
        inchisCell: _withCtx(({ data }) => [
          (data.data.DataInchidere)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("span", { class: "dot" }, null, -1),
                _createTextVNode("Închis", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("span", { class: "dot" }, null, -1),
                _createTextVNode("Deschis", -1)
              ]))]))
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "TicketNr",
            caption: "Număr",
            width: 150,
            "cell-template": "nrCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataCreare",
            caption: "Deschis",
            "data-type": "datetime",
            format: "dd.MM.yyyy HH:mm",
            width: 160
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "StatusTichet.Name",
            caption: "Stare",
            width: 150,
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PrioritateTichet.Name",
            caption: "Prioritate",
            width: 120,
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "UserMessage",
            caption: "Mesaj",
            "min-width": 220
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "HRMessage",
            caption: "Răspuns HR",
            "min-width": 200,
            "cell-template": "raspunsCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DataInchidere",
            caption: "Închis",
            "data-type": "date",
            format: "dd.MM.yyyy",
            width: 130,
            "cell-template": "inchisCell"
          }),
          _createVNode(_component_DxPaging, { "page-size": 12 }),
          _createVNode(_component_DxSorting, { mode: "single" }),
          _createVNode(_component_DxFilterRow, { visible: true })
        ]),
        _: 1
      }, 8, ["data-source"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogTicket,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogTicket) = $event)),
      "max-width": "520",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          rounded: "xl",
          class: "dlg-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_v_icon, {
                  color: "#fff",
                  size: "20"
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("mdi-ticket-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                _createElementVNode("div", { class: "dlg-title" }, "Tichet HR nou"),
                _createElementVNode("div", { class: "dlg-desc" }, "Cere o adeverință sau un document de la HR.")
              ], -1)),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                color: "#fff",
                size: "small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogTicket = false))
              })
            ]),
            _createVNode(_component_v_card_text, { class: "pa-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _ctx.ticketValid,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ticketValid) = $event)),
                  ref: "ticketForm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.ticketForm.DocumentTypeID,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ticketForm.DocumentTypeID) = $event)),
                      items: _ctx.tipuriDoc,
                      "item-title": "Denumire",
                      "item-value": "ID",
                      label: "Tip document",
                      variant: "outlined",
                      density: "comfortable",
                      class: "mb-4",
                      rules: [_ctx.required],
                      loading: _ctx.loadingTipuri,
                      "hide-details": "auto"
                    }, null, 8, ["modelValue", "items", "rules", "loading"]),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.ticketForm.PriorityTypesID,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ticketForm.PriorityTypesID) = $event)),
                      items: _ctx.prioritati,
                      "item-title": "Name",
                      "item-value": "ID",
                      label: "Prioritate",
                      variant: "outlined",
                      density: "comfortable",
                      class: "mb-4",
                      "hide-details": "auto",
                      clearable: ""
                    }, null, 8, ["modelValue", "items"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.ticketForm.UserMessage,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ticketForm.UserMessage) = $event)),
                      label: "Mesaj / Detalii",
                      variant: "outlined",
                      density: "comfortable",
                      rows: "3",
                      rules: [_ctx.required],
                      "hide-details": "auto"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.ticketError)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "error",
                      variant: "tonal",
                      density: "compact",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.ticketError), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dlg-foot" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogTicket = false))
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  class: "btn-nou px-6",
                  loading: _ctx.ticketLoading,
                  disabled: !_ctx.ticketValid,
                  onClick: _ctx.submitTicket
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode("mdi-send", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[18] || (_cache[18] = _createTextVNode("Trimite ", -1))
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}